(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const initTabs = () => {
      const allTabs = document.querySelectorAll('.tab__button');
      
      allTabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();

          // Get the container specific to this section
          const sectionWrapper = this.closest('.tabs-section-wrapper');
          const tabsInSection = sectionWrapper.querySelectorAll('.tab__button');
          const contentsInSection = sectionWrapper.querySelectorAll('.custom__tab-content');

          const contentId = this.dataset.contentId;
          const targetContent = document.getElementById(contentId);

          // Reset Active Classes
          tabsInSection.forEach(function(t) { t.classList.remove('active'); });
          contentsInSection.forEach(function(c) { c.classList.remove('active'); });

          // Set New Active Classes
          this.classList.add('active');
          if(targetContent) {
            targetContent.classList.add('active');
          }
        });
      });
    };

    // Initialize on load and on editor changes
    initTabs();
    document.addEventListener('shopify:section:load', initTabs);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
